import { render, staticRenderFns } from "./ConversationHeader.vue?vue&type=template&id=66fef674&scoped=true&"
import script from "./ConversationHeader.vue?vue&type=script&lang=js&"
export * from "./ConversationHeader.vue?vue&type=script&lang=js&"
import style0 from "./ConversationHeader.vue?vue&type=style&index=0&id=66fef674&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fef674",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66fef674')) {
      api.createRecord('66fef674', component.options)
    } else {
      api.reload('66fef674', component.options)
    }
    module.hot.accept("./ConversationHeader.vue?vue&type=template&id=66fef674&scoped=true&", function () {
      api.rerender('66fef674', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/conversation/ConversationHeader.vue"
export default component.exports